import type { GetEntitiesRequest } from '@backstage/catalog-client';
import type { Entity } from '@backstage/catalog-model';
import type { TypedGetEntitiesRequest } from '@ipen-portal/plugin-common';

import { useAsync } from 'react-use';

import { useGetEntitiesByFilterCallback } from './useGetEntitiesByFilterCallback';
import { useMemoValue } from './useMemoValue';

export const useGetEntitiesByFilter = <T extends Entity>(
  request?: null | TypedGetEntitiesRequest<T>,
  options?: {
    skip?: boolean;
  },
) => {
  const skip = options?.skip === true;
  const { predicate, ...requestWithoutPredicate } = request ?? {};

  const callback = useGetEntitiesByFilterCallback();
  const normalizedRequest = useMemoValue(requestWithoutPredicate);

  return useAsync(async () => {
    // CHALLENGE: try to get the rid of the cast (`as GetEntitiesRequest`) below
    const result = skip
      ? []
      : await callback(normalizedRequest as GetEntitiesRequest);
    return predicate ? result?.filter(predicate) : (result as T[]);
  }, [callback, normalizedRequest, predicate, skip]);
};
